import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilterRegularReportIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M18.9 22.3a1 1 0 0 1 1.1 1v3.8q-.1 1-1.1 1.1H18q-1-.1-1.1-1v-3.8q.1-1 1.1-1.1zm4.5-4.6q1 .2 1.1 1.2V27q-.1 1-1.1 1.1h-.8q-1-.1-1.1-1v-8.3q.1-1 1.1-1.1zm4.5 1.6q1 .1 1.1 1v6.8q-.1 1-1.1 1.1H27q-1-.1-1.1-1v-6.8q.1-1 1.1-1.1zM27.5 6q1.4.2 1.5 1.5 0 .6-.4 1L20 17v.4a3 3 0 0 0-.6 1.7v1.4h-1.9v-4q0-.6.4-.9l7.2-7.1H6.8l7.2 7.1q.3.3.4.9V25h.6v2q0 .5.2 1H15a3 3 0 0 1-3-3V17L3.3 8.5q-.3-.4-.4-1Q3.2 6.2 4.5 6z" })
});
export default SvgFilterRegularReportIcon;
